import { EventBus } from "../../../eventbus";
import { baseUrl } from "../../../config.js";

export default {
  data() {
    return {
      foldername: "",
      description: "",
      color: "CCC",
      company: this.$store.state.company,
      user: this.$store.state.user,
      error: false,
    };
  },
  created() {
    setTimeout(() => {
      if (this.$refs.foldername) {
        this.$refs.foldername.focus();
      }
    }, 300);
  },
  methods: {
    addSpace(e) {
      e.preventDefault();

      let formData = new FormData();

      if (this.$refs.addSpaceForm) {
        formData = new FormData(this.$refs.addSpaceForm);
      } else {
        formData.append("foldername", this.foldername);
        formData.append("description", this.description);
        formData.append("color", this.color);
      }

      formData.append("private", 1);
      formData.append("folder", "null");
      formData.append("myspace", 0);

      this.$axios.post(baseUrl + "/folderadd", formData).then((response) => {
        if (
          response.data.success == false &&
          response.data.msg == "folder_exists"
        ) {
          this.error = true;
        }
        if (
          response.data.success == true &&
          response.data.msg == "folder_added"
        ) {
          EventBus.$emit("closeallactions");

          this.$router.push(
            "/" + this.company + "/home/expanded/" + response.data.folder_id
          );

          //refresh folders
          EventBus.$emit(`desktop-files-update`);
          EventBus.$emit(`tree-overview-reset`);
        }
      });
    },
  },
};
